import { usePaginatedQuery, useQuery } from 'react-query'
import { useState, useEffect, useCallback } from 'react'
import { toast } from 'react-toastify'
import fetchingService, { clearCache } from '../../services/api/learning-resources-fetch'
import useCurrentUser from '../use-current-user'
import useDebounce from '../use-debounce'
import useRefreshToken from '../use-refresh-token'
import useLearningResourcesFilters from '../use-learning-resources-filters'
import { get } from 'lodash'
import useCacheKeys from '../use-cache-keys'
import useApi from '../use-api'

const useLearningResources = ({
    filters: filterOverrides = {},
}) => {
    //  We don't want to do queries unless current user is loaded
    const { currentUser } = useCurrentUser()
    const cacheKeys = useCacheKeys()
    const { api, url, endpoints} = useApi()

    //  Use the context filters if possible
    const { filters: contextFilters } = useLearningResourcesFilters()

    const filters = { ...contextFilters, ...filterOverrides}

    const {
        offset,
        limit,
        name,
        dimensions,
        types
    } = filters

    const {
        data,
        isLoading,
        isFetching
    } = useQuery(
        [cacheKeys.LEARNING_RESOURCES, filters],
        () => api.get(url(endpoints.learningResources, {}, { offset, limit, n: name, d: dimensions, t: types })),
        {
            enabled: currentUser,
        }
    )

    return {
        isBusy: isFetching || isLoading,
        learningResources: data ? data.items : [],
        total: data ? data.total : 0
    }
}

export default useLearningResources